import React, { useState } from 'react';
import { Input } from 'antd';
import {
	SendOutlined,
	AudioOutlined,
	AlignCenterOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';

const InputWrapper = styled.div`
	position: relative;
	width: 100%;
`;

const StyledInput = styled(Input)`
	padding: 12px 96px 12px 16px;
	font-size: 16px;
	height: auto;
	background: #ffffff !important;
	border: 1px solid rgba(0, 0, 0, 0.05) !important;
	backdrop-filter: blur(21px);
	border-radius: 10px;

	&:hover,
	&:focus {
		border-color: #61af4a;
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
	}

	&::placeholder {
		color: #999;
	}
`;

const IconButton = styled.button`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s ease;
	color: white;
	padding: 0;
	// background: #169191;
	background: ${({ theme }) => theme.CQColors.secondaryColor};
	border: 1px solid #ffffff;
	box-shadow: 0px 4px 4px rgba(25, 160, 65, 0.25);
	border-radius: 10px;

	&:hover {
		&:hover {
			background: ${({ theme }) => theme.CQColors.secondaryColor};
			color: ${({ theme }) => theme.CQColors.white} !important;
		}
		transform: translateY(-50%) scale(1.05);
	}

	&:disabled {
		background: #d9d9d9 !important;
		cursor: not-allowed;
		transform: translateY(-50%);
	}

	svg {
		width: 16px;
		height: 16px;
	}
`;

const SendButton = styled(IconButton)`
	right: 8px;
	svg {
		rotate: -45deg;
	}
	&:hover {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
	}
	&:disabled {
		background: #d9d9d9 !important;
		cursor: not-allowed;
		transform: translateY(-50%);
	}
`;

const MicButton = styled(IconButton)`
	right: 48px;
	background: transparent;
	border: none;
	box-shadow: none;
	color: #61af4a;
	svg {
		rotate: 270deg;
	}
`;

const ReclaimInput = ({ onSubmit }) => {
	const [value, setValue] = useState('');

	const handleSubmit = () => {
		if (value.trim()) {
			onSubmit(value);
			setValue('');
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleSubmit();
		}
	};

	const handleVoiceInput = () => {
		// Voice input functionality can be implemented here
		console.log('Voice input clicked');
	};

	return (
		<InputWrapper>
			<StyledInput
				placeholder="Type to get started"
				value={value}
				onChange={(e) => setValue(e.target.value)}
				onKeyPress={handleKeyPress}
			/>
			{/* <MicButton onClick={handleVoiceInput}>
				<AlignCenterOutlined />
			</MicButton> */}
			<SendButton onClick={handleSubmit} disabled={!value.trim()}>
				<SendOutlined />
			</SendButton>
		</InputWrapper>
	);
};

export default ReclaimInput;
